// Relative by default: API calls go to the same origin that served the app,
// so one built image works on any host (prod, localhost, staging). The env
// vars remain as optional overrides for unusual setups; empty strings count
// as unset (hence || rather than ??).
export const API_URL = import.meta.env.VITE_API_URL || '';
export const WS_URL =
  import.meta.env.VITE_WS_URL ||
  (location.protocol === 'https:' ? 'wss' : 'ws') + '://' + location.host;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  ADMIN: '/admin',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PROJECT: '/project/:projectId',
  SETTINGS: '/settings',
  ABOUT: '/about',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  DETAILS: '/details',
  ALPHA_OVERVIEW: '/alpha-overview',
  PRICING: '/pricing',
} as const;
